"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _reduxSaga = _interopRequireDefault(require("redux-saga"));

var _effects = require("redux-saga/effects");

var _reduxDevtoolsExtension = require("redux-devtools-extension");

var _policyReducer = _interopRequireDefault(require("./policy-reducer"));

var _reducer = _interopRequireDefault(require("../policy/Members/reducer"));

var _reducer2 = _interopRequireDefault(require("../policy/consumer/reducer"));

var _reducer3 = _interopRequireDefault(require("../notification/reducer"));

var _reducer4 = _interopRequireDefault(require("../page-header/reducer"));

var _reducer5 = _interopRequireDefault(require("../spinner-overlay/reducer"));

var _policySaga = _interopRequireDefault(require("./policy-saga"));

var _saga = _interopRequireDefault(require("../policy/Members/saga"));

var _saga2 = _interopRequireDefault(require("../policy/consumer/saga"));

var _reducer6 = _interopRequireDefault(require("../policy/resourceLabels/reducer"));

var _saga3 = _interopRequireDefault(require("../policy/resourceLabels/saga"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var saga = /*#__PURE__*/regeneratorRuntime.mark(function saga() {
  return regeneratorRuntime.wrap(function saga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.all)([_policySaga.default, _saga.default, _saga2.default, _saga3.default]);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, saga);
});

var configureStore = function configureStore() {
  var sagaMiddleware = (0, _reduxSaga.default)();
  var middleware = [sagaMiddleware];
  var store = (0, _redux.createStore)((0, _redux.combineReducers)({
    policyReducer: _policyReducer.default,
    membersReducer: _reducer.default,
    consumerReducer: _reducer2.default,
    notification: _reducer3.default,
    pageHeader: _reducer4.default,
    spinnerOverlay: _reducer5.default,
    resourceLabelsReducer: _reducer6.default
  }), (0, _reduxDevtoolsExtension.composeWithDevTools)(_redux.applyMiddleware.apply(void 0, middleware)));
  sagaMiddleware.run(saga);
  return store;
};

var _default = configureStore;
exports.default = _default;